import HttpMethod from '../../Services/httpMethods'
import { ApiResponse } from '../../Services/types';
import { makeRequest } from '../../Services/restcall';

// export async function GetAllBenefitsBySolicitudeGroupedByBusinessIdAPI(businessId:string, value: Object): Promise<ApiResponse> {
//     return await makeRequest(HttpMethod.POST, '/api/business/benefits-assignment-business-report?businessId='+businessId,value)
// }
export async function ChangePasswordAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/change-password',value)
}
export async function ResetPasswordAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/reset-password',value)
}
export async function ForgotPasswordAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/forgot-password',value)
}
export async function GetAllClientsAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/identity',value)
}
export async function PostClientsAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/register',value)
}
export async function LoginAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/identity/login',value)
}